module.exports = __webpack_public_path__ + "img/instructions_1.0010ad6a.png";